if(!customElements.get('custom-collection-list')){
    class CustomCollectionList extends HTMLElement {
        constructor(){
          super();
  
          this.init();
        }
  
        init(){
            this.swiperContainer = this.querySelector('.swiper-container');
            if(this.swiperContainer){
              this.initSwiper();
            }
        }
    
        initSwiper(){
            var loop = (this.swiperContainer.dataset.loop == 'true')? true : false;
            var numPerView = parseInt(this.swiperContainer.dataset.numPerView);
        
            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                spaceBetween: 30,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: {
                    0: {
                        slidesPerView: (numPerView > 2)? 2 : numPerView
                    },
                    992: {
                        slidesPerView: numPerView
                    }
                },
                observer: true,
                observeSlideChildren: true
            }
        
            if(this.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev')
                }
            }
    
            if(this.swiperContainer.dataset.autoplay == 'true'){
                let speed = this.swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }
    
            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();
            this.getVisibleSlides();
            this.checkPagination();

            this.swiper.on('slideChange', () => {
                this.getVisibleSlides();
            });

            this.swiper.on("resize", () => {
                this.checkPagination();
            })
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }

        checkPagination(){
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }

            var showPagination = false;
            if(btns.prev){
                if(btns.prev.getAttribute('aria-disabled') == 'false'){
                    showPagination = true;
                }
            }
            if(btns.next){
                if(btns.next.getAttribute('aria-disabled') == 'false'){
                    showPagination = true;
                }
            }

            if(!showPagination){
                this.querySelector('.swiper-pagination-wrapper').style.display = 'none';
            }else{
                this.querySelector('.swiper-pagination-wrapper').style.display = 'block';
            }
        }

        refresh(){
            if(this.swiperContainer){
              this.initSwiper();
            }
        }
    }
    
    customElements.define('custom-collection-list', CustomCollectionList);
}